import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

// Read shape of one Topic Management grid row (view__comms_topics): a
// cfg.comms_topics row plus its aggregated cfg.comms_topic_roles. Distinct
// from the Phase 0 CommsTopicModelSchema (id/label only, for globalConfigs).
export const CommsTopicGridModelSchema = z
  .object({
    comms_topics__id: z.string(),
    comms_topics__label: z.string(),
    comms_topics__role_ids: z.array(z.string()),
    comms_topics__role_labels: z.string(),
    comms_topics__role_count: z.number(),
    comms_topics__date_modified: z.string()
  })
  .strict()

export const CommsTopicGridModelFields = makeFieldKeys(CommsTopicGridModelSchema)

export type CommsTopicGridModel = z.infer<typeof CommsTopicGridModelSchema>

export function validateCommsTopicGridModel(data: unknown): CommsTopicGridModel {
  try {
    return validateWithZodSchema(CommsTopicGridModelSchema, data, 'comms topic grid model')
  } catch (error) {
    throw new Error(`Comms topic grid model validation failed: ${error}`)
  }
}
